import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import styles from '../pr.module.css';
import MessageDisplay from '../../../components/message/MessageDisplay';

// Define initial form state
const initialFormData = {
    base_fare: '',
    distance_rate: '',
    time_rate: '',
    time_interval: '',
    service_rate: '',
    surge_multiplier: '',
    effective_date: '',
    end_date: '',
    description: ''
};

const EditAdd = ({ data, setOpen, handleSubmit }) => {
    const [formData, setFormData] = useState(initialFormData);
    const [message, setMessage] = useState()

    useEffect(() => {
        console.log("clicked", data)
        setFormData(data ? { ...data } : initialFormData);
    }, [data]);

    const inputs = [
        { name: 'base_fare', type: 'number', placeholder: 'Enter the base fare' },
        { name: 'distance_rate', type: 'number', placeholder: 'Enter the distance rate' },
        { name: 'time_rate', type: 'number', placeholder: 'Enter the time rate' },
        { name: 'time_interval', type: 'number', placeholder: 'Enter the time interval' },
        { name: 'service_rate', type: 'number', placeholder: 'Enter the service rate' },
        { name: 'surge_multiplier', type: 'number', placeholder: 'Enter the surge multiplier' },
        { name: 'cancellation_fee', type: 'number', placeholder: 'Enter the cancel price' },
        { name: 'effective_date', type: 'date' },
        { name: 'end_date', type: 'date' },
        { name: 'description', type: 'text', placeholder: 'Enter the description \n(price model for)' }
    ];

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        if (type === "number") {
            let newValue = value;

            // Allow only numbers and at most one dot
            if (!/^\d*\.?\d*$/.test(newValue)) {
                return;
            }
            setFormData(prev => ({ ...prev, [name]: newValue }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value || "" }));
        }
    };

    const handleSubmitClick = async () => {
        const preparedData = {
            ...formData,
            effective_date: formData.effective_date || null,
            end_date: formData.end_date || null,
        };

        try {
            const response = await handleSubmit({
                ...preparedData,
                pricing_id: data?.pricing_id
            });

            const mess = data?.pricing_id ? "Update not successful" : "Adding new price model not successful";

            if (response?.success == true) {
                setOpen(false);
                setFormData(initialFormData);
            } else {
                setMessage({ type: 'error', message: mess });
            }
        } catch (error) {
            console.error("Error submitting data:", error);
            setMessage({ type: 'error', message: error?.response?.data?.message || "Server down" });
        }
    };


    const excludedFields = ["effective_date", "end_date"];

    const isFormComplete = Object.entries(formData)
        .filter(([key]) => !excludedFields.includes(key))
        .every(([_, value]) => String(value).trim() !== '');


    return (
        <div className={styles.container}>
            <div style={{
                display: 'flex',
                flexDirection: 'row'
            }}>
                <MessageDisplay message={message} />
                <h2 style={{ margin: '0', alignSelf: 'center' }}>
                    {!data ? 'Add new price model' : `Edit ${data.description}`}
                </h2>
                <button
                    className={styles.closebtn}
                    onClick={() => {
                        setOpen(false);
                        setFormData(initialFormData);
                        console.log("close button clicked")
                    }}>
                    <FontAwesomeIcon icon={faXmark} />
                </button>
            </div>

            <div
                className={styles.con}
            >
                {inputs.map(({ name, type, placeholder }, index) => (
                    <div key={index}
                        className={styles.ipcon}
                    >
                        <label htmlFor={name}>
                            {name.replace("_", " ").charAt(0).toUpperCase() + name.replace("_", " ").slice(1)}
                        </label>

                        {name === "description" ? (
                            <textarea
                                id={name}
                                name={name}
                                placeholder={placeholder}
                                value={formData[name]}
                                onChange={handleChange}
                                className={styles.textarea}
                            />
                        ) : (
                            <input
                                id={name}
                                name={name}
                                type={type}
                                placeholder={placeholder}
                                value={formData[name]}
                                onChange={handleChange}
                                min="0"
                                className={styles.input}
                            />
                        )}
                    </div>
                ))}
            </div>

            <button
                onClick={handleSubmitClick}
                className={`${styles.submitButton} ${isFormComplete ? styles.show : ""}`}
            >
                Submit
            </button>
        </div>
    );
};

export default EditAdd;
